import { IApplicationState } from '../../types/redux';

export function getRateOurEstimation(state: IApplicationState) {
  return state.rateOurEstimation;
}
